import { render } from "./nameForm.vue?vue&type=template&id=36fe55f2"
import script from "./nameForm.vue?vue&type=script&lang=js"
export * from "./nameForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__